/**
 * ALL GraphQL for the Home page lives here (centralized-queries rule).
 *
 * Both queries are PUBLIC — they answer without a login, scoped by the
 * `x-tenant-id` header the Apollo client always sends. Verified 2026-09-02:
 *   - `availableModules` answers unauthenticated (81 registered).
 *   - `publicSopEpisodes(tenantId)` answers unauthenticated with PUBLISHED episodes.
 * (`sopEpisodes` — the admin list — does NOT; it returns "Not authenticated".)
 *
 * Types come from `src/generated/graphql.ts` (`ModuleInfo`, `SopEpisode`) — never
 * re-declared here. Home does not import from `../modules` or `../state-of-play`:
 * a page owns the queries it makes.
 */
import { gql } from "@apollo/client";
import type { ModuleInfo, SopEpisode } from "../../generated/graphql";

/** Live count for "N MODULES REGISTERED · SEE ALL →". Ids only — the page needs the length. */
export const HOME_AVAILABLE_MODULES = gql`
  query HomeAvailableModules {
    availableModules {
      id
    }
  }
`;

export type HomeAvailableModulesData = {
  availableModules: Array<Pick<ModuleInfo, "id">>;
};

/** Latest published State of Play episodes for the #stateofplay cards. */
export const HOME_PUBLIC_SOP_EPISODES = gql`
  query HomePublicSopEpisodes($tenantId: String!, $limit: Int) {
    publicSopEpisodes(tenantId: $tenantId, limit: $limit) {
      id
      slug
      title
      headline
      subtitle
      episodeNumber
      publishedAt
    }
  }
`;

export type HomePublicSopEpisode = Pick<
  SopEpisode,
  "id" | "slug" | "title" | "headline" | "subtitle" | "episodeNumber" | "publishedAt"
>;

export type HomePublicSopEpisodesData = {
  publicSopEpisodes: HomePublicSopEpisode[];
};

export type HomePublicSopEpisodesVars = {
  tenantId: string;
  limit?: number;
};
